import React from "react";

interface BranchStatusConfirmModalProps {
  mode: "activate" | "deactivate";
  branchName: string;
  onCancel: () => void;
  onConfirm: () => void;
  isProcessing?: boolean;
}

export const BranchStatusConfirmModal: React.FC<BranchStatusConfirmModalProps> = ({
    mode,
    branchName,
    onCancel,
    onConfirm,
    isProcessing = false,
  }) => {
    const isDeactivate = mode === "deactivate";
    const title = isDeactivate ? "Ngưng chi nhánh" : "Kích hoạt chi nhánh";
    const description = isDeactivate
      ? `Bạn có chắc muốn ngưng chi nhánh "${branchName}"?`
      : `Bạn có chắc muốn kích hoạt chi nhánh "${branchName}"?`;
    const confirmLabel = isDeactivate ? "Ngưng ngay" : "Kích hoạt";
  
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 px-4">
        <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl">
          <h3 className="text-xl font-semibold text-slate-800">{title}</h3>
          <p className="mt-3 text-sm text-slate-600">{description}</p>
          <div className="mt-6 flex justify-end gap-3">
            <button onClick={onCancel} disabled={isProcessing} className="rounded-full border px-4 py-2">
              Hủy
            </button>
            <button
              onClick={onConfirm}
              disabled={isProcessing}
              className={`rounded-full px-4 py-2 text-white ${
                isDeactivate ? "bg-amber-500" : "bg-emerald-500"
              }`}
            >
              {isProcessing ? "Đang xử lý..." : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    );
  };

export default BranchStatusConfirmModal;
